import React from 'react';
import logo from '../../images/ac-logo.png'

const Footer = () => (
    <footer>
        <div className="ac-page">
            <span className="ac-banner">
                <a href="https://www.aptcrowd.co"><img className="ac-banner-logo" src={logo} />
                &copy; Apt Crowd, LLC {(new Date()).getFullYear()}</a>
            </span>
            <span className="ac-legal">
                <a href="/app/tos" target="_blank">Terms</a>
                <a href="/app/privacy" target="_blank">Privacy</a>
            </span>
        </div></footer>
);

export default Footer;